import React from 'react';
import { Card, Badge, Button } from 'react-bootstrap';
import { FaEye, FaPhoneAlt, FaCalendarAlt, FaCommentAlt } from 'react-icons/fa';
import { format } from 'date-fns';
import Const from '../../../util/Constants';
const getInitials = (name = '') => {
  const words = name.trim().split(' ');
  return words.length >= 2
    ? `${words[0][0]}${words[1][0]}`.toUpperCase()
    : name[0]?.toUpperCase();
};

const getColor = (name = '') => {
  const colors = [
    '#6C5CE7', '#00B894', '#0984E3', '#E17055', '#D63031',
    '#FD79A8', '#00CEC9', '#FAB1A0', '#FFEAA7', '#81ECEC'
  ];
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  return colors[Math.abs(hash) % colors.length];
};
  

const LatestSiteVisits = ({navigate, data = [] }) => {
    const onPreview = data => {
    if (data.modelNo == Const.Lead) {
      navigate(`/lead/preview/${data.modelId}`);
    } else if (data.modelNo == Const.Contact) {
      navigate(`/contact/preview/${data.modelId}`);
    }
  };
  return (
    <Card className="border-0 shadow-sm h-100 rounded-4" style={{ background: 'linear-gradient(145deg, #ffffff, #f8f9fa)' }}>
      <Card.Body className="p-3">
        <div className="d-flex justify-content-between align-items-center mb-2">
          <h6 className="fw-bold text-dark mb-0">Recent Site Visits</h6>
          <FaCalendarAlt className="text-warning" size={18} />
        </div>

        {data.length === 0 ? (
          <div className="text-center text-muted pt-4 pb-2 small">No site visits found.</div>
        ) : (
          <div style={{ maxHeight: '300px', overflowY: 'auto', paddingRight: 4 }}>
            {data.map((visit, index) => (
              <div
                key={index}
                className="d-flex justify-content-between align-items-start p-2 rounded-3 mb-2"
                style={{
                  backgroundColor: '#fff',
                  border: '1px solid #eaeaea',
                  fontSize: '13px',
                }}
              >
                {/* Left Side */}
                <div className="d-flex gap-2 flex-grow-1">
                  <div
                    className="rounded-circle d-flex align-items-center justify-content-center fw-semibold text-white"
                    style={{
                      background: `linear-gradient(135deg, ${getColor(visit.leadName)}, ${getColor(visit.leadName)}cc)`,
                      width: 36,
                      height: 36,
                      fontSize: '13px',
                      flexShrink: 0,
                      marginRight: '15px',
                    }}
                  >
                    {getInitials(visit.leadName)}
                  </div>

                  <div className="flex-grow-1">
                    {/* Top Row: Name + Date/Time */}
                    <div className="d-flex justify-content-between align-items-start mb-1">
                      <div className="fw-semibold text-dark" style={{ fontSize: '14px', fontWeight: '700', }}>
                        {visit.leadName}
                      </div>
                      <div className="d-flex gap-1 small text-muted text-nowrap">
                        <Badge bg="light" text="dark" className="px-2 py-1 border rounded-pill" style={{marginRight: '5px'}}>
                          {visit.displayDate}
                        </Badge>
                        <Badge bg="light" text="dark" className="px-2 py-1 border rounded-pill"style={{marginRight: '5px'}}>
                          {visit.displayTime}
                        </Badge>
                      </div>
                    </div>

                    {/* Phone */}
                    <div className="text-muted small d-flex align-items-center mb-1">
                      <FaPhoneAlt size={11} className="me-2" />
                      {visit.phone}
                    </div>

                    {/* Feedback + Comment */}
                    {visit.feedback && (
                      <div className="text-muted small mb-1">
                        <strong>Feedback:</strong> {visit.feedback}
                      </div>
                    )}
               {visit.comment && (
                <div
                  className="mt-2 px-3 py-2 d-flex align-items-start"
                  style={{
                    backgroundColor: '#f8f9fa',
                    borderLeft: '4px solid #0d6efd',
                    borderRadius: '0.5rem',
                    fontSize: '0.85rem',
                    boxShadow: 'inset 0 1px 2px rgba(0,0,0,0.05)',
                    color: '#343a40',
                  }}
                >
                  <FaCommentAlt className="text-primary mt-1" size={13} />:
                  <div>
                    <div>{visit.comment}</div>
                  </div>
                </div>
              )}
                  </div>
                </div>

                {/* Right: View Button */}
                <Button
                  variant="outline-primary"
                  size="sm"
                  className="d-flex align-items-center justify-content-center mt-1"
                  style={{ borderRadius: '50%', width: '30px', height: '30px', padding: 0 }}
                  onClick={() => onPreview(visit)}
                >
                  <FaEye size={13} />
                </Button>
              </div>
            ))}
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

export default LatestSiteVisits;
